import React, { useState } from "react";
import { Fields } from "./Fields";
import MappingValidations from "../Processors/Validators/MappingValidations";
import MappingGroup from "./mappings/MappingGroup";
import MappingSkeleton from "./mappings/MappingSkeleton";
import { Add } from "@mui/icons-material";

const NEW_MAPPING_ID = "__new__";

const FieldMappings = (props) => {
  const fieldDescriptions = Fields[props.mappingType];

  const validationMap = {
    pharmacy: (col, name) => MappingValidations.isValidPharmacyColumnMapping(col, name),
    medical: (col, name) => MappingValidations.isValidMedicalColumnMapping(col, name),
    pharmacy_encounter: (col, name) =>
      MappingValidations.isValidPharmacyEncounterColumnMapping(col, name),
    medical_encounter: (col, name) =>
      MappingValidations.isValidMedicalEncounterColumnMapping(col, name),
  };

  const isValidColumnMapping = validationMap[props.mappingType] || validationMap.medical;

  const columnMappingFields = props.fieldMappingFields.map((column) => {
    const matchingFieldDescription = fieldDescriptions[column.name];
    return { ...matchingFieldDescription, ...column };
  });

  const [editingId, setEditingId] = useState(null);

  const startCreating = () => {
    props.setCreatingMapping(true);
    setEditingId(NEW_MAPPING_ID);
  };

  const stopCreating = () => {
    props.setCreatingMapping(false);
    setEditingId(null);
  };

  const createMapping = ({ name, mappings }) => props.createMapping(name, mappings);

  const editingLocked = editingId !== null;

  return (
    <div className="pill__container">
      <div className="mapping__toolbar">
        <div
          className="button button--outline button--white"
          onClick={editingLocked ? undefined : startCreating}
        >
          <Add fontSize="small" />
          New Mapping
        </div>
      </div>
      <div className="mapping__container">
        {props.mappings.map((mapping, index) => (
          <MappingGroup
            key={mapping.id}
            mapping={mapping}
            index={index}
            fields={columnMappingFields}
            isValidColumnMapping={isValidColumnMapping}
            editing={editingId === mapping.id}
            editingLocked={editingLocked}
            isInUse={props.inUseMappingIds.includes(mapping.id)}
            isOnlyMapping={props.mappings.length === 1}
            onStartEdit={() => setEditingId(mapping.id)}
            onStopEdit={() => setEditingId(null)}
            onSave={props.updateMapping}
            onDelete={props.deleteMapping}
            dropFnRef={props.dropFnRef}
          />
        ))}
        {props.creatingMapping ? (
          <MappingGroup
            key={NEW_MAPPING_ID}
            mapping={{ id: NEW_MAPPING_ID, name: "", mappings: {} }}
            index={props.mappings.length}
            fields={columnMappingFields}
            isValidColumnMapping={isValidColumnMapping}
            editing
            editingLocked={editingLocked}
            isNew
            onStopEdit={stopCreating}
            onCreate={createMapping}
            dropFnRef={props.dropFnRef}
          />
        ) : (
          <MappingSkeleton fields={columnMappingFields} />
        )}
      </div>
    </div>
  );
};

export default FieldMappings;
